import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const subRef = useRef<HTMLParagraphElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elements = [titleRef.current, subRef.current, ctaRef.current];
    elements.forEach((el, i) => {
      if (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        setTimeout(() => {
          if (el) {
            el.style.transition = 'opacity 1s ease, transform 1s ease';
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }
        }, 300 + i * 250);
      }
    });
  }, []);

  const scrollToCheck = () => {
    const el = document.getElementById('self-check');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.wixstatic.com/media/380b5a_83c03cb399414e149ecb88f08a83672d~mv2.jpeg"
          alt="sanctuary background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      </div>

      {/* Brand name */}
      <div className="absolute top-8 left-1/2 -translate-x-1/2 z-10">
        <p className="text-white/90 tracking-[0.5em] text-sm font-sans font-light">
          ——  埼玉県川口市  ——
        </p>
      </div>

      {/* Main content */}
      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto w-full">
        <div className="mb-8">
          <span className="font-serif text-white/95 text-2xl md:text-3xl italic tracking-widest">
            sanctuary
          </span>
        </div>

        <h1 ref={titleRef} className="font-serif text-white text-3xl md:text-5xl leading-snug tracking-wide mb-8">
          「自分の中に答えがあると<br />言われても、<br />それがどれだかわからない。」
        </h1>

        <p ref={subRef} className="font-sans text-white/85 text-base md:text-lg leading-loose tracking-wider mb-12 font-light">
          心の仕組みから、<br className="md:hidden" />
          あなたに起きていることを<br />
          一緒に見てみませんか。
        </p>

        <div ref={ctaRef}>
          <button
            onClick={scrollToCheck}
            className="whitespace-nowrap cursor-pointer inline-block px-10 py-4 bg-white/15 border border-white/60 text-white font-sans text-sm tracking-[0.2em] hover:bg-white/25 transition-all duration-300 rounded-none"
          >
            まずはセルフチェックをしてみる
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 opacity-60">
        <div className="w-px h-12 bg-white animate-pulse" />
        <span className="text-white font-sans text-xs tracking-widest">scroll</span>
      </div>
    </section>
  );
}
